<!-- Loading Spinner (shown during navigation events) -->
<div class="app__loader-mask" #loaderEl>
  <div class="app__loader-wrapper">
    <div class="app__loader">
      <mat-spinner [diameter]="16" class="app__loader-spinner"></mat-spinner>
      <span class="app__loader-text">Loading...</span>
    </div>
  </div>
</div>

<!-- Main site header -->
<div [hidden]="!showHeader" class="app__header-container"></div>

<!-- Primary router outlet -->
<router-outlet></router-outlet>

<!--
  Note: The Google Places API requires an instance of an HTML element to be passed to it at initialization time.
  According to the documentation, it's supposed to render the attributions in that container. However:

    - The API doesn't seem to ever render any attributions. The element remains empty even after calling various
      methods from the library.
    - We want to initialize the Google service once at the start of the application, while rendering the attributions
      multiple times (wherever we use Google data).

  Thus, we give the Google Places API a valid element in the footer portion of the application. This element is
  available at application start, and is always visible (in case an attribution does get rendered there, we don't want
  to inadvertently hide it). However, since we will be manually placing our own static attributions in all parts of the
  app that rely on Google data, we don't want to make this element too prominent - thus, we place it in the footer
  area of the application.
-->
<div #googleAttributionEl></div>

<!-- Footer ad -->
<div class="app__footer-ad" *ngIf="showFooter">
  <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="1"></app-open-x-adunit>
</div>

<!-- Main site footer -->
<div [hidden]="!showFooter" class="app__footer-container"></div>
